module.exports = __webpack_public_path__ + "static/media/add_icon.6841451e.svg";